import styled from 'styled-components';

export const Wrapper = styled.button<{ selected?: boolean; completed?: boolean }>`
  position: relative;
  box-sizing: border-box;
  width: -webkit-fill-available;
  width: 100%;
  padding: 10px 0;
  display: flex;
  cursor: ${({ selected }) => (selected ? 'default' : 'pointer')};
  justify-content: center;
  align-items: center;
  border-radius: 8px 8px 0px 0px;
  box-shadow: 7px -3px 17px rgba(0, 0, 0, 0.045);
  border-bottom: ${({ theme, selected, completed }) =>
    selected || completed ? `3px solid ${theme.brandTheme.brand100}` : `1px solid ${theme.palette.grays20}`};
  p {
    color: ${({ selected, theme, completed }) =>
      selected || completed ? theme.palette.grays100 : theme.palette.grays50};
  }
  .cover {
    cursor: default;
    position: absolute;
    width: 100%;
    height: 115%;
    background-color: ${({ theme }) => theme.palette.white70};
    z-index: 10;
  }
  transition: 100ms ease-in-out;
`;

export const Cover = styled.div<{ whiteOverlay?: boolean }>`
  display: ${({ whiteOverlay }) => (whiteOverlay ? 'flex' : 'none')};
  cursor: default;
  position: absolute;
  width: 100%;
  height: 115%;
  background-color: ${({ theme }) => theme.palette.white70};
  z-index: 10;
`;
